<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.batchImport')"
    width="400px"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form label-width="110px" label-position="left">
        <el-form-item :label="$t('Partners.firstPlease') + $t('SeaExport.TemplateDownload')">
          <span style="color: #0A0AFF;cursor: pointer" :title="$t('SeaExport.TemplateDownload')" @click="downLoadTemplate">{{ fileName }}</span>
        </el-form-item>
        <el-form-item :label="$t('Partners.selectImportFile')">
          <el-upload
            v-if="innerVisible"
            ref="upload"
            :limit="1"
            class="upload-demo"
            :action="action"
            :auto-upload="false"
            accept=".xls,.xlsx"
            :data="params"
            :on-success="uploadSuccess"
            :on-error="uploadExcelError"
          >
            <el-button slot="trigger" :title="$t('Information.SelectFile')" type="primary">{{ $t('Information.SelectFile') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="">
          <label>{{ $t('CargoMsg.Cargo_FileSizeCannotExceed20m2') }}</label>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer">
      <div style="text-align: center">
        <el-button type="primary" @click="submitUpload">{{ $t('CargoMsg.Cargo_StartUploading') }}</el-button>
        <el-button @click="closeHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>

import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import URL from '@/api/urlTranslator'
import { cache, cacheName } from '@/utils/cacheManager'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'ImportDialog',
  props: {
    visible: { type: Boolean, required: true },
    action: { type: String, default: () => '' },
    fileName: { type: String, default: () => '' },
    folderName: { type: String, default: () => '' },
    params: { type: Object, default: () => {} }, // 请求参数
    errorTipDetail: { type: Boolean, default: () => false } // 是否提醒具体错误内容
  },
  data() {
    return {
      loading: false,
      URL,
      innerVisible: false,
      uploadSetting: ''
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
  },
  methods: {
    // 下载模板
    downLoadTemplate() {
      ExportUtils.downloadTemplateFile(this.fileName, this.folderName)
    },
    // 开始导入-确定导入
    submitUpload() {
      const files = this.$refs.upload.uploadFiles
      if (!files || files.length <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return
      }
      this.loading = getLoading4Cxt(this)
      this.$refs.upload.submit()
    },
    // 导入成功
    uploadSuccess(response, file, fileList) {
      console.log('response:', response)
      this.loading.close()
      if (response && response.data) {
        const documentId = response.data
        this.$confirm(this.$t('Message.ImportSuccessful1'), this.$t('FileHistory.Tips'), {
          confirmButtonText: this.$t('Partners.downloadImportResults'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'success'
        }).then(() => {
          this.downloadResultLog(documentId)
          this.closeHandler()
        })
        this.$refs.upload.clearFiles()
        if (this.loading) this.loading.close()
      } else {
        this.uploadExcelError(response)
      }
    },
    uploadExcelError(response) {
      if (this.errorTipDetail && response && response.errors && response.errors.length > 0) {
        this.$message.error({ 'message': response.errors[0].message })
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
      this.closeHandler()
    },
    closeHandler() {
      this.$refs.upload.clearFiles()
      if (this.loading) this.loading.close()
      this.innerVisible = false
      this.$emit('uploadSuccess')
      this.$emit('onClose')
    },
    // 下载导入结果
    downloadResultLog(documentId) {
      // 从云存储上下载文件
      if (!documentId) {
        this.$message.warning(this.$t('SeaExport.NoCorrespondingFile'))
        return
      }
      const url = `${URL.common.findByFileId}/${documentId}?sessionId=${this.sessionId}`
      window.open(url)
    }
  }
}
</script>

<style scoped>

</style>
